import { Box, BoxProps } from "@chakra-ui/react";

interface CalendarTimeDividerProps extends BoxProps {
  time: string;
  timeWidth: BoxProps["width"];
}

export const CalendarTimeDivider = ({
  time,
  timeWidth,
  ...props
}: CalendarTimeDividerProps) => {
  return (
    <Box display={"flex"} alignItems={"center"} width={"100%"} {...props}>
      <Box
        fontWeight={"400"}
        opacity={"0.5"}
        fontSize={"12px"}
        minWidth={timeWidth}
      >
        {time}
      </Box>
      <Box
        width={"100%"}
        height={"1px"}
        backgroundColor={"black"}
        opacity={"0.2"}
      ></Box>
    </Box>
  );
};
